window.JRS = window.JRS || {};

/**
 * jrs-v2-cart-event-bridge.js
 *
 * Mirrors JRS.EventBus `cart:updated` signals onto the DOM as a
 * CustomEvent('cart:updated'). The v2 stack (CartAPI, cart-edit-flow,
 * cart-controller) emits cart:updated on the EventBus only, but several
 * DOM-based listeners — the header total (jrs-main-header.liquid) and
 * cart-sticky-checkout.js — listen for a DOM `cart:updated`. Without this
 * bridge those listeners never fire on cart-page qty/remove/edit, so the
 * header total goes stale until a full reload.
 *
 * One subscriber catches every emitter because they share the one EventBus.
 * A re-entrancy guard prevents a DOM listener that re-emits from looping.
 */
(function(JRS) {
  'use strict';

  var EventBus = JRS.EventBus;
  if (!EventBus || typeof EventBus.on !== 'function') return;
  if (typeof document === 'undefined') return;
  if (JRS._cartEventBridgeInstalled) return;
  JRS._cartEventBridgeInstalled = true;

  var _dispatching = false;

  EventBus.on('cart:updated', function(data) {
    if (_dispatching) return;
    _dispatching = true;
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data || null }));
    } catch (error) {
      console.error('[CartEventBridge] Failed to mirror cart:updated to DOM:', error);
    } finally {
      _dispatching = false;
    }
  });
})(window.JRS);
